import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex: none;
  margin-top: 1rem;
`
const Button = styled.button`
  flex: 0;
  min-width: 6rem;
`
const TextContainer = styled.div`
  flex: none;
`


export default function ErrorDialog({ message, onClick }) {
  return (
    <Container>
      <TextContainer>
        <strong>ERROR: </strong>{message}
      </TextContainer>
      <ButtonContainer>
        <Button onClick={onClick} >
          OK
        </Button>
      </ButtonContainer>
    </Container>
  );
}
